/* eslint-disable max-classes-per-file */
import * as React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

import AkEmptyState from '@atlaskit/empty-state';
import { IllustrationComponent } from '@atlassian/illustrations';

// These should only be used for error flags, use the components for all other error messages
export const errorFlagMessages = defineMessages({
  title: {
    id: 'common.generic-error.title',
    defaultMessage: 'Something went wrong',
    description: 'Generic error message title',
  },
  description: {
    id: 'common.generic-error.description',
    defaultMessage: 'Try again later.',
    description: 'Generic error message description',
  },
});

const errorMessages = defineMessages({
  error: {
    id: 'common.generic-error',
    defaultMessage: 'Something went wrong. Try again later.',
    description: 'Generic error message',
  },
});

export const GenericErrorMessage = () => <FormattedMessage {...errorMessages.error} />;

interface GenericErrorProps {
  testId?: string;
  header?: string;
  headingLevel?: number;
  description?: React.ReactNode;
}

export const GenericError: React.FC<Omit<GenericErrorProps, 'formatMessage'>> = ({
  header,
  headingLevel,
  description,
  testId = 'generic-error',
}) => {
  const { formatMessage } = useIntl();

  return (
    <AkEmptyState
      testId={testId}
      renderImage={() => <IllustrationComponent illustrationKey="ErrorColor" width={160} height={160} alt="" />}
      header={header || formatMessage(errorFlagMessages.title)}
      description={description || formatMessage(errorFlagMessages.description)}
      width="wide"
      headingLevel={headingLevel}
    />
  );
};
